<template>
  <div>
    <router-view />

    <BottomNav v-if="showBottomNav" />
  </div>
</template>

<script>
import BottomNav from "@/views/BottomNav.vue";

export default {
  components: {
    BottomNav,
  },
  data() {
    return {
      sideNavOpen: false,
      hiddenBottomNavRoutes: ["/", "/admin_login", "/register", "/admin-reg"],
    };
  },
  computed: {
    showBottomNav() {
      const currentPath = this.$route.path;
      const shouldHide = this.hiddenBottomNavRoutes.includes(currentPath);
      const user = localStorage.getItem("user");
      return !!user && !shouldHide;
    },
  },
};
</script>